import type { DynamicFormConfig } from '@core/ask-hr-dynamic-forms-types';
import { createProviderToken } from '@core/common-legacy';

export const { inject: injectDynamicFormConfigs, provide: provideDynamicFormConfigs } =
  createProviderToken<new () => DynamicFormConfig>('DynamicFormConfig')(true);
